<template>
    <div id="Iconic">
        <mobileHeader v-if="isMobile == 'Mobile'" touterNum=1></mobileHeader>
        <Header v-else></Header>
        <backhead :title="titleLabel"></backhead>
        <div class="list flex app-content" :class="{ Mobileclass: isMobile == 'Mobile' }">
            <div class="box hand" v-for="(item, index) in arrList" :key="index" @click="todetails(item.id)">
                <img :src="item.image" alt="" class="pic">
                <div class="con">
                    <p class="tit app-title">{{ item.title }}</p>
                    <p class="tim">{{ item.start_time }} - {{ item.end_time }}</p>
                </div>
            </div>
            <div class="box" v-if="arrList.length % 4 > 1"></div>
            <div class="box" v-if="arrList.length % 4 == 2"></div>
        </div>
    </div>
</template>

<script setup>
    import { ref, watch, computed } from 'vue';
    import { getshowList } from "../utils/gerData";
    import { currentLanguage } from "../utils/lang";
    import router from '@/router';
    const isMobile = localStorage.getItem('userAgent')

    const arrList = ref([]);

    import { backheadTitles,imageurl } from "../utils/i18nLabels";
    const titleLabel = computed(() => backheadTitles.iconic[currentLanguage.value || 'zh'])

    // 跳详情
    function todetails(id) {
        router.push("/details?pid=1&id=" + id)
    }
    // 获取列表数据
    function getList() {
        let queryParams = {
            pid: 1,
            page: 1,
            pageSize: 100,
            is_classical: true
        }
        getshowList(queryParams).then(res => {
            const data = res.data
            data.list.map(item => {
                item.start_time = item.start_time.slice(0, 10).replace(/-/g, ".");
                item.end_time = item.end_time.slice(0, 10).replace(/-/g, ".");
                item.image = item.image ? imageurl + item.image : undefined
            })
            arrList.value = data.list;
        });
    }
    getList()

    watch(currentLanguage, () => {
        getList()
    })
</script>

<style scoped>
    #Iconic{
        overflow: hidden;
    }
    .list{
        margin-top: 200px;
        flex-wrap: wrap;
        padding: 30px 60px;
        .box{
            width: 24%;
            font-size: 17px;
            color: #3a3a3a;
            text-align: left;
            background: #e5e5e5;
            margin-bottom: 70px;
            .pic{
                width: 100%;
                height: 288px;
                object-fit: cover;
                display: block;
            }
            .con{
                padding: 20px 16px 16px 16px; 
                    
                .tit{
                    font-size: 22px;
                    color: #000;
                    margin-bottom: 16px;
                    white-space: nowrap; /* 不换行 */
                    overflow: hidden; /* 隐藏超出的内容 */
                    text-overflow: ellipsis; /* 用省略号表示被隐藏的部分 */

                }
            }
        }
        .hand{
            cursor: pointer;
        }
    }
    .Mobileclass{
        display: block;
        margin-top: 160px;
        padding: 0 22px;
        .box{
            width: 100%;
            &:first-child{
                padding-top: 0;
            }
        }
    }
</style>